module.exports = __webpack_public_path__ + "img/tipimg_t@2x.9ce7ff1f.png";